import SuperRepository from '../superRepository'

export default new (class PartnersAffiliateRepository extends SuperRepository {
  baseUri() {
    return 'partner_advertiser_affiliate'
  }
  checkUnique = (data) => this.httpClient().post(`${this.baseUri()}/check_unique`, data)
  exportDuplicates = (params) => this.httpClient().get(`${this.baseUri()}/duplicates/export`, {}, params)
})()
